<template lang='pug' src='./block-img-text.pug'></template>

<script>
export default {
  props: {
    content: {
      Type: Object,
      default: () => {}
    },
    imagePosition: {
      Type: String,
      default: 'left'
    },
    bodyAlign: {
      Type: String,
      default: 'center'
    },
    colImage: {
      Type: String,
      default: 'col-sm-9'
    },
    colText: {
      Type: String,
      default: 'col-sm-9'
    },
    colImageOffset: {
      Type: String,
      default: 'col-sm-offset-0'
    },
    colTextOffset: {
      Type: String,
      default: 'col-sm-offset-0'
    }
  }
}
</script>



// WEBPACK FOOTER //
// block-img-text.vue?24966394